<template>
  <div class="h-100">
    <object-grid
      model-class="QualityIssue"
      flow-subtype=""
      class="h-100"
      grid-max-height="100%"
      :colStateLocalStorageKey="'vendorProfile'"
      :fixedFilterKwargs="fixedFilterKwargs"
      :excludeFields="excludeFields"
    ></object-grid>
  </div>
</template>

<script>
  export default {
    name: 'VendorQualityIssues',
    props: {
      resource: {
        type: Object,
        required: true,
      },
    },
    mixins: [],
    data() {
      return {
        excludeFields: ['vendor'],  // this works now because we are using fixedFilterKwargs
        fixedFilterKwargs: {
          vendor: this.resource.id,
        },
      };
    },
    computed: {},
    mounted() {},
    methods: {},
  };
</script>
